export const PAY_BALANCE = 1 //余额
export const PAY_ALIPAY = 2 //支付宝
export const PAY_WECHAT = 3 //微信
export const PAY_CARD = 4 // 银行卡
